/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TasksControllerCreateMutationRequest, TasksControllerCreateMutationResponse, TasksControllerCreate400, TasksControllerCreate401, TasksControllerCreate403 } from "../../models/tasksController/TasksControllerCreate";

function getTasksControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/tasks` as const }  
  return res
}

/**
 * @summary Create a new task
 * {@link /api/v1/tasks}
 */
export async function tasksControllerCreate(data?: TasksControllerCreateMutationRequest, config: Partial<RequestConfig<TasksControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TasksControllerCreateMutationResponse, ResponseErrorConfig<TasksControllerCreate400 | TasksControllerCreate401 | TasksControllerCreate403>, TasksControllerCreateMutationRequest>({ method : "POST", url : getTasksControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}